/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProfileImage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ProfileImage({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/Profile/PersonPaymentAccount/Content/ProfileImage",
  presignedUrl
  
}) {
let paymentAccountPayerPersonValueData = fromData.useDataFormat({ viewPath,
context: 'payment_account',
path: 'payer_person',
format: fromFormat.initials,
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 profile_url={presignedUrl}
 data="payment_account.payer_person"
 format="/Data/format.js initials"
 initials={paymentAccountPayerPersonValueData}
 backgroundColor={dtColorsNeutral200}
 height={40}
 width={40}
/>
{children}
</React.Fragment>)
}